import {ComponentType} from 'react';
import {LighthouseReviewData} from 'src/app/api/model/response/LighthouseReviewResponse';
import ODQLighthouseTemplate from 'src/app/component/lighthouse/template/ODQLighthouseTemplate';

/**
 * Props every Review-tab template receives. Everything outside the tab body — decision
 * footer, modals, error banners — stays with LighthouseReview and is shared.
 */
export interface LighthouseTemplateProps {
    reviewData: LighthouseReviewData;
    auditCheckResponses: Record<string, string>;
    onAuditCheckChange?: (label: string, value: string) => void;
    onViewAttachment?: (fileId: string) => void;
    isReadOnly: boolean;
}

/**
 * Maps a review's `caseSubType` to a custom Review-tab layout. A miss is the normal case and
 * falls back to the default four-quadrant grid, so adding an entry affects only that subtype.
 *
 * Keyed on `caseSubType` rather than `reviewTemplateId`: it is always present on the
 * GetLighthouseReview payload and is the same key LighthouseSectionConfig uses. Keys must
 * match EERS byte-for-byte.
 */
export const lighthouseTemplateRegistry: Record<string, ComponentType<LighthouseTemplateProps>> = {
    ODQ: ODQLighthouseTemplate,
    Reliability: ODQLighthouseTemplate
};
